module.exports = __webpack_public_path__ + "img/step32_3-people.54cb9338.png";